import { Component } from '@angular/core';
import { MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-idle-dialog',
    templateUrl: './idle-dialog.component.html',
    styleUrls: ['./idle-dialog.component.scss'],
    imports: [MatDialogActions, MatButton],
})
export class IdleDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<IdleDialogComponent>,
        private translate: TranslateService
    ) {
        this.dialogRef.disableClose = true;
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }
}
